import React from 'react';
import './MiniCross.scss';

export const MiniCross : React.FC = () => <span className="c-minicross" />;
